export const strokeCapButtIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9 3v14h11v-2h-9V5h9V3zM8 8v4h4v-1h8V9h-8V8z"/></svg>`,
  name: 'stroke-cap-butt',
};
